import { CENTER_ORDER, OPERATING_HOURS } from './consts'
import type { HourPriority, PrioritySnapshot } from './types'

export const cloneHour = (value: HourPriority): HourPriority =>
  value.ranked === undefined ? { order: [...value.order], wait: value.wait } : { order: [...value.order], wait: value.wait, ranked: value.ranked }
export const cloneHours = (hours: Record<number, HourPriority>): Record<number, HourPriority> =>
  Object.fromEntries(Object.entries(hours).map(([key, value]) => [key, cloneHour(value)]))
/** 첫 조회 전 화면 초기값. 서버 값이 아니다. */
export const createInitialSnapshot = (): PrioritySnapshot => ({
  base: Object.fromEntries(OPERATING_HOURS.map((hr) => [hr, { order: [...CENTER_ORDER], wait: 0 }])),
  scenarios: [],
  exceptions: {},
})
